export const checkFullScreen = () => {
  const fullScreenClass = document.getElementsByClassName("vjs-fullscreen");
  // fullscreenが有効な場合
  if (true && typeof screen !== "undefined" && !!fullScreenClass && (window.innerHeight == screen.height || fullScreenClass && fullScreenClass.length > 0)) {
    return true;
  } else {
    return false;
  }
};